import loadable from '@loadable/component';

export const ChangePaymentDetails = loadable(() => import('./ChangePaymentDetails'));
